import { render, staticRenderFns } from "./Totais.vue?vue&type=template&id=794f48ae"
import script from "./Totais.vue?vue&type=script&lang=js"
export * from "./Totais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports